import { Box, Text, VStack } from '@bpba/ui-components';
import { GenericCard } from '@bpba/modules-components';
import { ProductoData } from '../../model/ProductoData';
import { CanjeButton } from '../shared/CanjeButton';
import { NumberFormat } from '../../config/NumberFormat';
import styled from 'styled-components';
import { LayoutProps, layout } from 'styled-system';
import { PointsComponent } from '../shared/PointsComponent';
import { TagDescuento } from '../catalogo/TagDescuento';

const TOP_LEFT_RADIUS = '8px';
const TOP_RIGHT_RADIUS = '24px';
const BOTTOM_LEFT_RADIUS = '24px';
const BOTTOM_RIGHT_RADIUS = '10px';

type DestacadoProps = {
  data: ProductoData;
  isLast: boolean;
  onClickCanje: (prod?: ProductoData) => void;
};
export const Destacado = ({ data, isLast, onClickCanje }: DestacadoProps) => {
  const descuentoAriaLabel = data.descuento ? `${data.descuento}.` : '';
  const pointsAriaLabel = data.puntos != null ? `${NumberFormat.formatNumber(data.puntos)} puntos.` : '';
  const tituloAriaLabel = data.titulo != null ? `${data.titulo}.` : '';
  const ariaLabel = `${descuentoAriaLabel} ${pointsAriaLabel} ${tituloAriaLabel}`;

  return (
    <GenericCard
      borderTopLeftRadius={TOP_LEFT_RADIUS}
      borderTopRightRadius={TOP_RIGHT_RADIUS}
      borderBottomLeftRadius={BOTTOM_LEFT_RADIUS}
      borderBottomRightRadius={BOTTOM_RIGHT_RADIUS}
      height={['200px', '215px']}
      isLast={isLast}
      flexDirection={'row'}
      data={data}
      width={'calc(100%-16px)'}
      margin={'8px'}
      aria-label={ariaLabel}
    >
      <Box
        backgroundColor={'white'}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'space-between'}
        borderRadius={'8px 0px 0px 16px'}
        padding={['24px', null, null, '32px 24px']}
        maxWidth={'50%'}
      >
        <VStack>
          <PointsComponent
            product={data}
            fontSize={['20px !important', null, null, '24px !important']}
            margin={'0 0 16px'}
            aria-hidden={true}
          />
          <StyledText
            fontSize={['15px !important', null, null, '16px !important']}
            margin="0"
            aria-hidden={true}
            maxHeight={72}
            overflow="hidden"
          >
            {data.titulo}
          </StyledText>
        </VStack>
        <CanjeButton title="Canjear" onClick={onClickCanje} product={data} />
      </Box>
      <Box maxWidth={'50%'} overflow={'hidden'} backgroundColor={'white'}>
        <TagDescuento
          left={'unset'}
          right={0}
          borderTopRightRadius={TOP_RIGHT_RADIUS}
          borderBottomLeftRadius={8}
          borderBottomRightRadius={0}
          texto={data?.descuento}
        />
        <StyledImg alt="" src={data.imagenes?.[0]} />
      </Box>
    </GenericCard>
  );
};

const StyledImg = styled.img({ objectFit: 'contain', width: '100%', height: '100%' });

const StyledText = styled(Text)<LayoutProps>(layout);
